import { Delete, Get, Post, Put, setFixHeader } from "../utils/request";

const currentUser: API.CurrentUser = {
    name: "",
    isAdmin: true,
    token: ""
};
export class MenuService{
    static async  listAll(){
        let result = await Get("/menu");
        return result.data;
    } 
}
